// Formats a plain number as Naira, e.g. 50000 -> "₦50,000.00"
export function formatNaira(amount) {
  return `₦${amount.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}

export const productCategories = [
  "All",
  "Apparel",
  "Accessories",
  "Limited Drops",
  "Vinyl & Physical",
  "Artist Collabs"
];

export const products = [
  {
    slug: "untamed-logo-hoodie",
    name: "Untamed Logo Hoodie",
    category: "Apparel",
    price: 50000,
    isNew: false,
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black", "Red", "White", "Navy", "Maroon", "Yellow"],
    desc:
      "Heavyweight fleece hoodie with an embroidered MusicUntamed logo across the chest. Relaxed fit, ribbed cuffs, and a kangaroo pocket — built for studio sessions and everyday wear alike.",
    material: "80% cotton, 20% polyester fleece blend",
    care: "Machine wash cold, tumble dry low",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-hoodie-main/600/600",
      "https://picsum.photos/seed/mu-hoodie-2/600/600",
      "https://picsum.photos/seed/mu-hoodie-3/600/600",
      "https://picsum.photos/seed/mu-hoodie-4/600/600",
      "https://picsum.photos/seed/mu-hoodie-5/600/600",
      "https://picsum.photos/seed/mu-hoodie-6/600/600"
    ]
  },
  {
    slug: "culture-snapback-cap",
    name: "Culture Snapback Cap",
    category: "Accessories",
    price: 75380,
    isNew: true,
    sizes: ["One Size"],
    colors: ["White"],
    desc:
      "A structured snapback with an embroidered MusicUntamed patch on the front panel. Adjustable strap, curved brim, one size fits most.",
    material: "100% cotton twill",
    care: "Spot clean only",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-merch-cap/600/600",
      "https://picsum.photos/seed/mu-cap-2/600/600",
      "https://picsum.photos/seed/mu-cap-3/600/600"
    ]
  },
  {
    slug: "culture-gift-tote-set",
    name: "Culture Gift Tote Set",
    category: "Accessories",
    price: 10380,
    isNew: false,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Natural"],
    desc:
      "A set of canvas gift totes finished with the MusicUntamed wordmark — perfect for merch drops, artist gifting, or everyday carry.",
    material: "100% heavyweight canvas",
    care: "Machine wash cold, line dry",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-merch-apparel/600/600",
      "https://picsum.photos/seed/mu-tote-set-2/600/600"
    ]
  },
  {
    slug: "corduroy-culture-jacket",
    name: "Corduroy Culture Jacket",
    category: "Apparel",
    price: 50000,
    isNew: false,
    sizes: ["S", "M", "L"],
    colors: ["Rust", "Olive", "Navy"],
    desc:
      "A relaxed corduroy overshirt with a woven MusicUntamed label at the hem. Layers easily over a tee or hoodie for studio-to-street days.",
    material: "100% cotton corduroy",
    care: "Machine wash cold, tumble dry low",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-merch-hoodies/600/600",
      "https://picsum.photos/seed/mu-jacket-2/600/600"
    ]
  },
  {
    slug: "logo-paper-tote",
    name: "Logo Paper Tote",
    category: "Accessories",
    price: 5380,
    isNew: false,
    sizes: ["One Size"],
    colors: ["Black"],
    desc:
      "A sturdy paper gift bag stamped with the MusicUntamed logo — the finishing touch for merch orders and artist gifting.",
    material: "Recycled kraft paper",
    care: "Wipe clean",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-merch-totebag/600/600",
      "https://picsum.photos/seed/mu-papertote-2/600/600"
    ]
  },
  {
    slug: "rema-calm-down-tour-tee",
    name: 'Rema "Calm Down" Tour Tee',
    category: "Artist Collabs",
    price: 42000,
    isNew: false,
    sizes: ["S", "M", "L", "XL"],
    colors: ["Black"],
    desc:
      "An official tour tee from Rema's Calm Down run, printed on a heavyweight cotton tee with tour dates on the back.",
    material: "100% heavyweight cotton",
    care: "Machine wash cold, tumble dry low",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-tour-tee/600/600",
      "https://picsum.photos/seed/mu-tour-tee-2/600/600"
    ]
  },
  {
    slug: "calm-down-vinyl-record",
    name: "Calm Down Vinyl Record",
    category: "Vinyl & Physical",
    price: 35000,
    isNew: false,
    sizes: ['12"'],
    colors: ["Purple"],
    desc:
      'A limited-pressing 12" vinyl of "Calm Down" by Rema, complete with collectible sleeve art.',
    material: "180g vinyl",
    care: "Store upright, away from direct sunlight",
    shipping: "Ships within 5-7 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-vinyl-1/600/600",
      "https://picsum.photos/seed/mu-vinyl-2/600/600"
    ]
  },
  {
    slug: "untamed-snapback-limited-orange",
    name: "Untamed Snapback — Limited Orange",
    category: "Limited Drops",
    price: 28000,
    isNew: true,
    sizes: ["One Size"],
    colors: ["Orange"],
    desc:
      "A limited-run colorway of our signature snapback, made in a small batch to mark this year's MusicUntamed Culture Fest.",
    material: "100% cotton twill",
    care: "Spot clean only",
    shipping: "Ships within 3-5 business days",
    returns: "Free returns within 14 days of delivery",
    images: [
      "https://picsum.photos/seed/mu-snapback-orange/600/600",
      "https://picsum.photos/seed/mu-snapback-orange-2/600/600"
    ]
  }
];

export function getProductBySlug(slug) {
  return products.find((p) => p.slug === slug);
}

export function getRelatedProducts(product, count = 4) {
  const rest = products.filter((p) => p.slug !== product.slug);
  const sameCategory = rest.filter((p) => p.category === product.category);
  const others = rest.filter((p) => p.category !== product.category);
  return [...sameCategory, ...others].slice(0, count);
}
